export const countElements = (arr: any) => {
  let count = 0;
  if (!arr.length) return count;
  for (let i = 0; i < arr.length; i++) {
    count++; // учитываем текущий элемент массива
    if (arr[i]?.children) {
      count += countElements(arr[i].children); // рекурсивно вызываем функцию для вложенных дочерних элементов
    }
  }
  return count;
};
